import React from 'react';
import './CarGrid.css';

import { PageTitle, Car, PagesNo, CarsSearch, ShowcaseHeader, EmptyState } from '../../../components';
import { useCarFilter, useFilterLoading } from '../../../utils';

import { FaCar } from 'react-icons/fa';

  
   
const CarGrid = () => {  

  // Fetch filtered and paginated car data using custom hook
  const {
    searchKeyword,
    matchingCars,
    sortOption,
    currentPage,
    displayedCars,
    handleFormSubmit,
    handleSort, 
    totalPages,
    handlePageChange,
  } = useCarFilter();

    // Use the custom hook `useFilterLoading` to determine if filtering is in progress
    const isFiltering = useFilterLoading(matchingCars, searchKeyword);
  
 
  return (    
    <> 

      {/* Page title */}
      <PageTitle title={'Car Grid'} page={'Car Grid'} />

      {/* Cars search component */}
      <CarsSearch onFormSubmit={handleFormSubmit} />

      <section className='cars'>

          {/* Check if there are matching cars */}
          {isFiltering ? null : matchingCars.length === 0 ? (
            <EmptyState
              icon={FaCar}
              title={`No cars found`}
              message="We couldn’t find any cars that match your search. Try a different keyword or explore our full car collection."
              buttonLink="Car-Grid"
              buttonText="Browse All Cars"
            />
          ) : (
          <>

            {/* Car header component */}
            <ShowcaseHeader
              showing={displayedCars.length}  // Number of cars currently displayed
              total={matchingCars.length}             // Total number of cars available
              sortOption={sortOption}         // Current sorting option
              handleSort={handleSort}         // Function to handle sorting changes
              isCar={true}                    // Indicates this is a car showcase
            />

            {/* Car container with grid layout */}
            <div className='car-container grid'>
              {/* Render each car component */}
              {displayedCars.map((car) => {
                return(  
                  <Car key={car.id} car={car} /> // Render a Car component for each car
                )
              })
              }
            </div>

            {/* pagination component */}
            <PagesNo currentPage={currentPage} totalPages={totalPages} handlePageChange={handlePageChange} />
            
          </>
          )}
      </section>
    </>
  )
}

export default CarGrid;